export default "__VITE_ASSET__eNs1$muL__"